import React from 'react'
import { Modal } from '@components/ui'

type ChartingDeleteItemKind = 'chart' | 'treatmentPlan' | 'phase'

type ChartingDeleteItemModalProps = {
  show: boolean
  itemName: string
  itemKind?: ChartingDeleteItemKind
  deleteDisabled?: boolean
  onCancel: () => void
  onDelete: () => void
}

const KIND_TITLE: Record<ChartingDeleteItemKind, string> = {
  chart: 'Delete chart',
  treatmentPlan: 'Delete Tx plan',
  phase: 'Delete phase',
}

const ChartingDeleteItemModal: React.FC<ChartingDeleteItemModalProps> = ({
  show,
  itemName,
  itemKind = 'chart',
  deleteDisabled = false,
  onCancel,
  onDelete,
}) => {
  const name = itemName.trim()
  const description =
    itemKind === 'treatmentPlan'
      ? 'Are you sure you want to delete this treatment plan? This cannot be undone.'
      : `Are you sure you want to delete ${name || `this ${itemKind}`}? This action can't be undone.`

  return (
    <Modal
      open={show}
      onClose={onCancel}
      size="xs"
      title={KIND_TITLE[itemKind]}
      description={description}
      primaryLabel="Delete"
      secondaryLabel="Cancel"
      primaryDestructive
      primaryDisabled={deleteDisabled}
      onPrimaryClick={onDelete}
      onSecondaryClick={onCancel}
    />
  )
}

export default ChartingDeleteItemModal
